import React from 'react'

import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine'
import style from './block.module.scss'

const ContactDetails: React.FC = () => {
    const props = {
        gutenbergEditorConfig: {
            allowedBlocks: ['smartfire/contact-details---row'],
            template: [['smartfire/contact-details---row'], ['smartfire/contact-details---row']],
        },
    }
    return <BlockWrapper.ChildrenBlocks {...(props as any)} className={style.block} />
}
export default defineBlock({
    Block: ContactDetails,
    smartProps: {},
    setup: {
        title: 'Coordonnées',
        parent: [],
    },
})
